module.exports = __webpack_public_path__ + "static/media/ATH.7edd8f64.gif";